export const orderStatuses = [
    {
        'name' : 'AWAITING_PAYMENT',
        'color': 'mat-blue-500-bg'
    },
    {
        'name' : 'PREORDER_RESERVED',
        'color': 'mat-orange-600-bg'
    },
    {
        'name' : 'PREORDER_CONFIRMED',
        'color': 'mat-orange-900-bg'
    },
    {
        'name' : 'PREORDER_AWAITING_PAYMENT',
        'color': 'mat-blue-500-bg'
    },
    {
        'name' : 'PAYMENT_ACCEPTED',
        'color': 'mat-green-500-bg'
    },
    {
        'name' : 'PREORDER_PAID',
        'color': 'mat-green-500-bg'
    },
    {
        'name' : 'PAID',
        'color': 'mat-green-500-bg'
    },
    {
        'name' : 'RESERVED',
        'color': 'mat-orange-500-bg'
    },
    {
        'name' : 'CANCELED',
        'color': 'mat-pink-500-bg'
    },
    {
        'name' : 'PREORDER_CANCELED',
        'color': 'mat-pink-500-bg'
    },
    {
        'name' : 'ORDER_CANCELEDBYUSER',
        'color': 'mat-pink-500-bg'
    },
    {
        'name' : 'PREORDER_CANCELEDBYUSER',
        'color': 'mat-pink-900-bg'
    },
    {
        'name' : 'REFUNDED',
        'color': 'mat-red-500-bg'
    },
    {
        'name' : 'PAYMENT_ERROR',
        'color': 'mat-red-900-bg'
    },
    {
        'name' : 'PAYMENT_REFUSED',
        'color': 'mat-red-900-bg'
    },
    {
        'name' : 'PAYMENT_EXPIRED',
        'color': 'mat-orange-900-bg'
    },
    {
        'name' : 'PAYMENT_EXPIRED',
        'color': 'mat-orange-400-bg'
    },
];



// WEBPACK FOOTER //
// /usr/app/src/app/core/services/orders/order-statuses.ts